// extracted by mini-css-extract-plugin
module.exports = {"bankIdIcon":"BankIDButton_bankIdIcon____rjD","button":"BankIDButton_button__rDH8J"};